import { FC } from 'react';
import SuperSelect from '../SuperSelect';
import SimpleFormItem from './subpage/simpleFormItem';
import { SelectOption, SelectValue, SuperSelectProps } from '../SuperSelect/interface';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { FormInstance } from 'antd/lib/form';

interface SuperSelectFormProps extends SuperSelectProps {
  onChange?: (value?: SelectValue, options?: SelectOption | SelectOption[], form?: FormInstance, index?: number, record?: any) => void;
}
export interface SimpleFormSuperSelectProps extends BaseSimpleFormProps {
  superSelectProps?: SuperSelectFormProps;
  enumCode?: string;
}
const SimpleFormSuperSelect: FC<SimpleFormSuperSelectProps> = props => {
  const { disabledRender, superSelectProps, form, enumCode, label, rules, ...restProps } = props;
  return (
    <SimpleFormItem label={label} rules={rules} {...restProps}>
      <SuperSelect
        allowClear
        showSearch
        style={DEFAULT_STYLE}
        enumCode={enumCode}
        placeholder={getSelectPlaceholder(label, superSelectProps, rules)}
        {...superSelectProps}
      />
    </SimpleFormItem>
  );
};

SimpleFormSuperSelect.displayName = SimpleFormItemEnum.SimpleFormSuperSelect;

export default SimpleFormSuperSelect;
